// Utils
import { isAnnotation } from '../../../../common/elements/utils/elementTypeUtils';
import preventElementTypePredicate from './preventElementTypePredicate';

export default preventElementTypePredicate(isAnnotation);
